export enum ApplicationStatus {
  Active = 'Active',
  Pitched = 'Pitched',
  Purgatory = 'Purgatory',
  Processing = 'Processing',
  ReadyToSubmit = 'Ready to Submit',
  Underwriting = 'Underwriting',
  NeedMoreInfo = 'Need More Info',
  PendingFunding = 'Pending Funding',
  Approved = 'Funded',
  Rejected = 'Rejected',
  Compliance = 'Compliance',
  NMICompleted = 'NMI - COMPLETED',
}
